import React from 'react';
import { Header } from '@s7/header';
export var HeaderWidgetSkeleton = function () { return React.createElement(Header.Skeleton, { position: "relative" }); };
